import {
  TITLE_NAME_PREVIEW,
  TITLE_NAME_NEW,
  TITLE_NAME_UPDATE,
  TITLE_NAME_REMOVE,
  TITLE_NAME_PROCESS_SUCCESS,
  TITLE_NAME_DATASOURCE_SUCCESS,
  TITLE_NAME_SEARCH,
  TITLE_NAME_PROCESS_RESET
  
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize:{},
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case TITLE_NAME_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case TITLE_NAME_NEW: {
      return {
          ...state,
          loader: true,
          process:{status:false,action:"",message:""}
      }
    }
    case TITLE_NAME_UPDATE:{
        return{
          ...state,
          loader:true,
          process:{status:false,action:"",message:""},
          dataSerialize:action.payload
        }
    }
    case TITLE_NAME_REMOVE: {
      return {
          ...state,
          loader: false,
          process:{status:false,action:"",message:""}
      }
    }
    case TITLE_NAME_SEARCH:{
        return {
            ...state,
            loader:false,
            keyword:action.payload
        }
    }
    case TITLE_NAME_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process:action.payload
      }
    }
    case TITLE_NAME_DATASOURCE_SUCCESS:{
        return {
            ...state,
            loader: false,
            dataSource: action.payload
        }
    }
    case TITLE_NAME_PROCESS_RESET:{
      return{
        ...state,
        process:{}
      }
    }
    default:
      return state
  }
}